import React from 'react';
import Dashboard from '../../components/Dashboard';
import MenuContainer from '../../components/custom-components/menu/MenuContainer';
import AdaptiveContainer from '../../components/containers/AdaptiveContainer';
import ApiKeyComponent from '../../components/page-components/profile/ApiKey';

const ApiKey = () => {
    return (
        <Dashboard title='dashboard'>
            <MenuContainer>
                <AdaptiveContainer>
                    <ApiKeyComponent />
                </AdaptiveContainer>
            </MenuContainer>
        </Dashboard>
    );
};

export default ApiKey;
